// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const NmapIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#9BDBF5"
      d="M12 7c5.46 0 12.1 5.79 11.2 6-6.36 1.5-6.7 4-11.2 4s-6.07-2.68-11-4c-1-.27 5.54-6 11-6"
    />
    <path
      fill="url(#nmap_svga)"
      d="M12 7c5.46 0 12.1 5.79 11.2 6-6.36 1.5-6.7 4-11.2 4s-6.07-2.68-11-4c-1-.27 5.54-6 11-6"
    />
    <circle cx={12} cy={12} r={5} fill="#98D7F1" />
    <circle cx={12} cy={12} r={5} fill="url(#nmap_svgb)" />
    <path
      stroke="#32596F"
      strokeLinecap="round"
      strokeWidth={0.05}
      d="M11.98 6.92v10.06M13.28 7.1l-2.6 9.71M14.49 7.62l-5.02 8.7M15.53 8.42l-7.11 7.11M16.32 9.47l-8.7 5.02M16.81 10.68l-9.7 2.6M16.98 11.98H6.92M16.8 13.28l-9.71-2.6M16.29 14.49 7.58 9.47M15.48 15.53 8.37 8.42M14.43 16.32l-5.02-8.7M13.22 16.81l-2.6-9.7"
    />
    <circle cx={12} cy={12} r={2} fill="#32596F" />
    <circle cx={12} cy={12} r={2} stroke="#fff" strokeWidth={0.1} />
    <circle cx={12} cy={12} r={4} stroke="#32596F" strokeWidth={0.05} />
    <circle cx={12} cy={12} r={5} stroke="#32596F" strokeWidth={0.05} />
    <circle cx={12} cy={12} r={1} stroke="#fff" strokeWidth={0.1} />
    <circle cx={12} cy={12} r={3} stroke="#32596F" strokeWidth={0.05} />
    <circle cx={12} cy={12} r={0.5} fill="#fff" />
    <path
      fill="#A6DDF3"
      d="M12 6.5c2.88 0 6 1.51 8.26 3 1.13.75 2.08 1.52 2.69 2.12q.46.45.68.8c.06.1.15.28.16.47a.6.6 0 0 1-.13.38.6.6 0 0 1-.34.22c-3.11.73-4.74 1.7-6.17 2.5A9.3 9.3 0 0 1 12 17.5c-2.37 0-3.97-.71-5.57-1.56S3.27 14.13.87 13.48a.62.62 0 0 1-.47-.54 1 1 0 0 1 .12-.5q.2-.38.65-.84c.59-.6 1.51-1.37 2.63-2.12C6.02 8 9.12 6.5 12 6.5m0 1c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5"
    />
    <path
      fill="url(#nmap_svgc)"
      d="M12 6.5c2.88 0 6 1.51 8.26 3 1.13.75 2.08 1.52 2.69 2.12q.46.45.68.8c.06.1.15.28.16.47a.6.6 0 0 1-.13.38.6.6 0 0 1-.34.22c-3.11.73-4.74 1.7-6.17 2.5A9.3 9.3 0 0 1 12 17.5c-2.37 0-3.97-.71-5.57-1.56S3.27 14.13.87 13.48a.62.62 0 0 1-.47-.54 1 1 0 0 1 .12-.5q.2-.38.65-.84c.59-.6 1.51-1.37 2.63-2.12C6.02 8 9.12 6.5 12 6.5m0 1c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5"
    />
    <path
      stroke="#32596F"
      strokeWidth={0.05}
      d="M12 6.5c2.88 0 6 1.51 8.26 3 1.13.75 2.08 1.52 2.69 2.12q.46.45.68.8c.06.1.15.28.16.47a.6.6 0 0 1-.13.38.6.6 0 0 1-.34.22c-3.11.73-4.74 1.7-6.17 2.5A9.3 9.3 0 0 1 12 17.5c-2.37 0-3.97-.71-5.57-1.56S3.27 14.13.87 13.48a.62.62 0 0 1-.47-.54 1 1 0 0 1 .12-.5q.2-.38.65-.84c.59-.6 1.51-1.37 2.63-2.12C6.02 8 9.12 6.5 12 6.5Zm0 1c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5Z"
    />
    <path
      fill="#D6EEF4"
      d="M12 6.5c2.88 0 6 1.51 8.26 3 1.13.75 2.08 1.52 2.69 2.12q.46.45.68.8c.06.1.15.28.16.47a.6.6 0 0 1-.13.38.6.6 0 0 1-.34.22c-3.11.73-4.74 1.7-6.17 2.5A9.3 9.3 0 0 1 12 17.5v-.25c2.31 0 3.57-.65 5.02-1.47s3.1-1.8 6.24-2.54a.4.4 0 0 0 .2-.12.4.4 0 0 0 .08-.23 1 1 0 0 0-.12-.34q-.2-.3-.65-.75c-.6-.59-1.52-1.34-2.65-2.09-2.17-1.43-5.13-2.87-7.86-2.96H12c-2.8 0-5.85 1.47-8.06 2.94-1.1.74-2.02 1.5-2.59 2.09q-.43.44-.61.77-.09.16-.1.36a.4.4 0 0 0 .3.33c2.42.65 4.02 1.63 5.6 2.48 1.59.84 3.15 1.53 5.46 1.53v.25c-2.37 0-3.97-.71-5.57-1.56S3.27 14.13.87 13.48a.62.62 0 0 1-.47-.54 1 1 0 0 1 .12-.5q.2-.38.65-.84c.59-.6 1.51-1.37 2.63-2.12C6.02 8 9.12 6.5 12 6.5m0 .75c2.65 0 5.63 1.41 7.84 2.88a18 18 0 0 1 2.9 2.35c.12.14.05.36-.13.41-2.88.74-4.47 1.69-5.83 2.45a8.6 8.6 0 0 1-4.38 1.4l-.4.01a10.3 10.3 0 0 1-5.22-1.48c-1.47-.77-3.02-1.72-5.27-2.39a.25.25 0 0 1-.13-.4l.33-.36c.54-.56 1.42-1.29 2.5-2.01C6.4 8.65 9.36 7.25 12 7.25m0 .25c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5"
    />
    <path
      fill="url(#nmap_svgd)"
      d="M12 6.5c2.88 0 6 1.51 8.26 3 1.13.75 2.08 1.52 2.69 2.12q.46.45.68.8c.06.1.15.28.16.47a.6.6 0 0 1-.13.38.6.6 0 0 1-.34.22c-3.11.73-4.74 1.7-6.17 2.5A9.3 9.3 0 0 1 12 17.5v-.25c2.31 0 3.57-.65 5.02-1.47s3.1-1.8 6.24-2.54a.4.4 0 0 0 .2-.12.4.4 0 0 0 .08-.23 1 1 0 0 0-.12-.34q-.2-.3-.65-.75c-.6-.59-1.52-1.34-2.65-2.09-2.17-1.43-5.13-2.87-7.86-2.96H12c-2.8 0-5.85 1.47-8.06 2.94-1.1.74-2.02 1.5-2.59 2.09q-.43.44-.61.77-.09.16-.1.36a.4.4 0 0 0 .3.33c2.42.65 4.02 1.63 5.6 2.48 1.59.84 3.15 1.53 5.46 1.53v.25c-2.37 0-3.97-.71-5.57-1.56S3.27 14.13.87 13.48a.62.62 0 0 1-.47-.54 1 1 0 0 1 .12-.5q.2-.38.65-.84c.59-.6 1.51-1.37 2.63-2.12C6.02 8 9.12 6.5 12 6.5m0 .75c2.65 0 5.63 1.41 7.84 2.88a18 18 0 0 1 2.9 2.35c.12.14.05.36-.13.41-2.88.74-4.47 1.69-5.83 2.45a8.6 8.6 0 0 1-4.38 1.4l-.4.01a10.3 10.3 0 0 1-5.22-1.48c-1.47-.77-3.02-1.72-5.27-2.39a.25.25 0 0 1-.13-.4l.33-.36c.54-.56 1.42-1.29 2.5-2.01C6.4 8.65 9.36 7.25 12 7.25m0 .25c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5"
    />
    <path
      stroke="#32596F"
      strokeWidth={0.05}
      d="M12 17.5c2.38 0 3.68-.67 5.15-1.5 1.43-.81 3.06-1.78 6.17-2.51a.6.6 0 0 0 .34-.22.6.6 0 0 0 .13-.38c0-.2-.1-.36-.16-.47a5 5 0 0 0-.68-.8c-.61-.6-1.56-1.37-2.7-2.12-2.25-1.49-5.37-3-8.25-3S6.02 8 3.8 9.48a17 17 0 0 0-2.63 2.12q-.45.46-.65.84a1 1 0 0 0-.12.5.6.6 0 0 0 .47.54c2.4.65 3.96 1.6 5.56 2.46S9.63 17.5 12 17.5Zm0 0v-.25m0 .25v-.25m0 0c2.31 0 3.57-.65 5.02-1.47s3.1-1.8 6.24-2.54a.4.4 0 0 0 .2-.12.4.4 0 0 0 .08-.23 1 1 0 0 0-.12-.34q-.2-.3-.65-.75c-.6-.59-1.52-1.34-2.65-2.09-2.17-1.43-5.13-2.87-7.86-2.96H12c-2.8 0-5.85 1.47-8.06 2.94-1.1.74-2.02 1.5-2.59 2.09q-.43.44-.61.77-.09.16-.1.36a.4.4 0 0 0 .3.33c2.42.65 4.02 1.63 5.6 2.48 1.59.84 3.15 1.53 5.46 1.53Zm0-10c2.65 0 5.63 1.41 7.84 2.88a18 18 0 0 1 2.9 2.35c.12.14.05.36-.13.41-2.88.74-4.47 1.69-5.83 2.45a8.6 8.6 0 0 1-4.38 1.4l-.4.01a10.3 10.3 0 0 1-5.22-1.48c-1.47-.77-3.02-1.72-5.27-2.39a.25.25 0 0 1-.13-.4l.33-.36c.54-.56 1.42-1.29 2.5-2.01C6.4 8.65 9.36 7.25 12 7.25Zm0 .25c-2.58 0-5.48 1.37-7.64 2.82a16 16 0 0 0-2.47 1.98c-.16.16-.08.41.13.48 2.05.67 3.52 1.55 4.88 2.27 1.54.82 2.97 1.45 5.1 1.45s3.24-.58 4.66-1.37c1.3-.74 2.82-1.64 5.46-2.37.2-.05.27-.29.13-.43a18 18 0 0 0-2.54-2C17.5 8.89 14.58 7.5 12 7.5Z"
    />
    <path stroke="#fff" strokeWidth={0.1} d="M12 8.95v6M14.95 12h-6" />
    <defs>
      <radialGradient
        id="nmap_svgb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 5 -5 0 12 12)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.42} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.78} stopColor="#fff" stopOpacity={0.7} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="nmap_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 10 -21.262 0 12.1 7.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="nmap_svga"
        x1={12}
        x2={12}
        y1={8.5}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.72} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="nmap_svgd"
        x1={12.09}
        x2={12.09}
        y1={7.5}
        y2={15.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>,
  "Nmap",
);
export default NmapIcon;
